import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_INFERIOR_STATISTICS',
    manual: true,
  });

  useEffect(() => {
    if (params.work_order_ids === '' || params.start === '' || params.end === '') {
    } else {
      let url = `/api/quality/analysis/sealing/inspection/qualified/rate`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return data || [];
});
